import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/views/layout/Layout'

Vue.use(Router)

export const constantRouterMap = [{
  path: '',
  component: Layout,
  redirect: '/home',
  name: "home",
  roles: ["admin"],
  meta: {title: '首页', icon: 'home'},
  children: [{
    path: 'home',
    name: 'home',
    roles: ["admin"],
    component: () => import('@/views/home/index'),
    meta: {title: '首页', icon: 'home'}
  }]
}, {
  path: '/login', roles: ["admin", "staff", "other"], component: () => import('@/views/login/index'), hidden: true
}, {
  path: '/404', roles: ["admin", "staff", "other"], component: () => import('@/views/404'), hidden: true
}]

export const asyncRouterMap = [{
  path: '/user',
  component: Layout,
  redirect: '/user/list',
  name: 'user',
  roles: ["admin"],
  meta: {title: '用户管理', icon: 'ums-role'},
  children: [{
    path: 'user',
    name: 'user',
    roles: ["admin"],
    component: () => import('@/views/user/list/index'),
    meta: {title: '注册用户', icon: 'ums-admin'}
  }],
}, {
  path: '/toys',
  component: Layout,
  redirect: '/toys/info',
  name: 'toys',
  roles: ["admin", "staff"],
  meta: {title: '文玩', icon: 'sms'},
  children: [{
    path: 'info',
    name: 'info',
    roles: ["admin"],
    component: () => import('@/views/toys/info/index'),
    meta: {title: '文玩列表', icon: 'product-list'}
  }, {
    path: 'list',
    name: 'list',
    roles: ["admin"],
    component: () => import('@/views/toys/comment/index'),
    meta: {title: '评论列表', icon: 'ums-admin'}
  }, {
    path: 'type',
    name: 'type',
    roles: ["admin"],
    component: () => import('@/views/toys/type/index'),
    meta: {title: '文玩类型', icon: 'ums-admin'}
  }]
}, {
  path: '/feedback',
  component: Layout,
  redirect: '',
  name: 'feedback',
  roles: ["admin"],
  meta: {title: '用户反馈', icon: 'ums'},
  children: [{
    path: 'feedback',
    name: 'feedback',
    roles: ["admin"],
    component: () => import('@/views/feedback/index'),
    meta: {title: '用户反馈', icon: 'product-comment'}
  }],
}, {path: '*', roles: ["admin"], redirect: '/404', hidden: true}]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}), routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js